import React, { useState, useEffect } from 'react'
import './header.css'
import { BsGithub } from 'react-icons/bs'
import { FaLinkedinIn } from 'react-icons/fa'
import { useLanguage } from '../../context/LanguageContext'
import HeaderPresentation from './HeaderPresentation'
import useScrollspy from '../../hooks/useScrollspy'

const Header = () => {
  const { t, lang, setLang } = useLanguage()
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const activeSection = useScrollspy(['Home', 'Skills', 'Projects', 'Services', 'Contact'])

  // Ferme le menu quand on scrolle de trop
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40)
      if (window.scrollY > 100) setMenuOpen(false)
    }
    window.addEventListener('scroll', onScroll)
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  // Bloque le scroll du body quand le menu est ouvert
  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : ''
    return () => { document.body.style.overflow = '' }
  }, [menuOpen])

  return (
    <header id="Home">
      <div className="header__moiastronaute">
        <img src={require("../../assets/sofiane.png")} alt="Sofiane Meziane"/>
      </div>

      {/* ===== TOP NAVBAR ===== */}
      <div className={`header__topnav${scrolled ? ' header__topnav--scrolled' : ''}`}>
        <div className="container header__topnav--inner">

          {/* Logo */}
          <a href="#Home" className="header__logo">Sofiane<span>.</span></a>

          {/* Hamburger (mobile only) */}
          <button
            className={`hamburger${menuOpen ? ' hamburger--open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Toggle menu"
          >
            <span /><span /><span />
          </button>

          {/* Desktop Links */}
          <ul className="header__menu">
            <li><a href="#Home" className={`header__navlink${activeSection === 'Home' ? ' header__navlink--active' : ''}`}>{t.nav.home}</a></li>
            <li><a href="#Skills" className={`header__navlink${activeSection === 'Skills' ? ' header__navlink--active' : ''}`}>{t.nav.skills}</a></li>
            <li><a href="#Projects" className={`header__navlink${activeSection === 'Projects' ? ' header__navlink--active' : ''}`}>{t.nav.projects}</a></li>
            <li><a href="#Services" className={`header__navlink${activeSection === 'Services' ? ' header__navlink--active' : ''}`}>{t.nav.services}</a></li>

            {/* Social icons */}
            <li>
              <a href="https://github.com/MezianeS" className='header__icon' target="_blank" rel="noreferrer">
                <BsGithub className='header__icon--params'/>
              </a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/sofianemeziane/" className='header__icon' target="_blank" rel="noreferrer">
                <FaLinkedinIn className='header__icon--params'/>
              </a>
            </li>

            {/* Language switcher */}
            <li className="header__lang">
              <button onClick={() => setLang('en')} className={`lang-btn${lang === 'en' ? ' lang-btn--active' : ''}`}>EN</button>
              <button onClick={() => setLang('fr')} className={`lang-btn${lang === 'fr' ? ' lang-btn--active' : ''}`}>FR</button>
              <button onClick={() => setLang('zh')} className={`lang-btn${lang === 'zh' ? ' lang-btn--active' : ''}`}>中文</button>
            </li>

            {/* CTA */}
            <li><a href="#Contact" className='header__connect'>{t.nav.connect}</a></li>
          </ul>
        </div>
      </div>

      {/* ===== MOBILE FULLSCREEN MENU ===== */}
      <div className={`mobile-menu${menuOpen ? ' mobile-menu--open' : ''}`}>
        <nav className="mobile-menu__nav">
          {[['#Home','Home', t.nav.home],['#Skills','Skills',t.nav.skills],['#Projects','Projects',t.nav.projects],['#Services','Services',t.nav.services],['#Contact','Contact',t.nav.connect]].map(([href, section, label], i) => (
            <a
              key={section}
              href={href}
              className={`mobile-menu__link${activeSection === section ? ' mobile-menu__link--active' : ''}`}
              style={{ transitionDelay: menuOpen ? `${i * 60}ms` : '0ms' }}
              onClick={() => setMenuOpen(false)}
            >
              {label}
            </a>
          ))}
        </nav>
        <div className="mobile-menu__footer">
          <div className="mobile-menu__lang">
            <button onClick={() => setLang('en')} className={`lang-btn${lang === 'en' ? ' lang-btn--active' : ''}`}>EN</button>
            <button onClick={() => setLang('fr')} className={`lang-btn${lang === 'fr' ? ' lang-btn--active' : ''}`}>FR</button>
            <button onClick={() => setLang('zh')} className={`lang-btn${lang === 'zh' ? ' lang-btn--active' : ''}`}>中文</button>
          </div>
          <div className="mobile-menu__socials">
            <a href="https://github.com/MezianeS" target="_blank" rel="noreferrer"><BsGithub /></a>
            <a href="https://www.linkedin.com/in/sofianemeziane/" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      <HeaderPresentation />
    </header>
  )
}

export default Header
